import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { addDoc, updateDoc } from "firebase/firestore";
import {
  contentsCollectionRef,
  designationsCollectionRef,
  getContentDoc,
  getDesignationDoc,
  uploadImgContent,
} from "../utils/firestoreHelpers";
import { useState } from "react";
import { formatDate } from "../utils/helpers";
import { businessTypes } from "../utils/constants";

const initialData = {
  title: "",
};

const initialErrorData = {
  title: "",
};

const EditDesignation = ({ onClose, prevData, dialogType }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(prevData ? prevData : initialData);
  const [error, setError] = useState(initialErrorData);

  const validate = () => {
    const { title } = data;
    let isValid = true;
    let tempError = { ...initialErrorData };
    if (!title) {
      isValid = false;
      tempError["title"] = "Title is required";
    }
    setError(tempError);
    return isValid;
  };

  const onSubmit = async () => {
    let isValid = validate();
    if (!isValid) return;
    // console.log("found valid");
    setLoading(true);
    const { title } = data;
    if (prevData) {
      // console.log("prevData :: ", prevData);
      const designationDoc = getDesignationDoc(prevData.id);
      // console.log("designationDoc :: ", designationDoc);
      const newFields = { title };
      // console.log("updating data");
      await updateDoc(designationDoc, newFields);
    } else {
      // console.log("prevData not found");
      const payload = { title };
      await addDoc(designationsCollectionRef, payload);
      // console.log("Data added");
    }
    setLoading(false);
    onClose();
  };

  const onChange = (e) => {
    let value = e.target.value;
    const name = e.target.name;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <form>
      <Modal show={true} onHide={() => {}}>
        <Modal.Header>
          <Modal.Title>{`${dialogType} Designation Content`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="title" className="form-label d-block">
              Title *
            </label>
            <input
              value={data.title}
              onChange={onChange}
              className="w-100 form-control"
              name="title"
              required
            />
            <p className="text-danger small">{error.title}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            {loading ? (
              <>
                <span
                  class="spinner-grow spinner-grow-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default EditDesignation;
